import { render, staticRenderFns } from "./DbcdR_Result.vue?vue&type=template&id=0f741c32"
import script from "./DbcdR_Result.vue?vue&type=script&lang=js"
export * from "./DbcdR_Result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports